import React from 'react'
import { SecondaryLink } from 'stylist'
import { isAbsoluteUrl } from 'utils/url'

const SmartSecondaryLink = ({ url, children }) => {
  return isAbsoluteUrl(url) ? (
    <SecondaryLink external href={url}>
      {children}
    </SecondaryLink>
  ) : (
    <SecondaryLink to={url}>
      {children}
    </SecondaryLink>
  )
}

export default SmartSecondaryLink


// WEBPACK FOOTER //
// ./src/components/SmartSecondaryLink.js